import React from 'react';
import * as Icons from 'lucide-react';
import { whyChoose, whyChooseImage } from '../../mock';

const WhyChoose = () => {
  return (
    <section className="relative overflow-hidden py-20 lg:py-28 bg-white">
      <div className="blob w-80 h-80 bg-brand-mint/25 top-10 -right-24" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center relative">
        <div className="relative order-2 lg:order-1">
          <img src={whyChooseImage} alt="Our carers" className="rounded-[2rem] object-cover w-full h-[500px] shadow-lg" />
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-white rounded-2xl shadow-xl px-7 py-4 text-center">
            <div className="font-heading font-bold text-2xl text-brand-blue">15+ yrs</div>
            <div className="text-xs text-slate-500 font-body">combined care experience</div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <span className="font-heading font-semibold text-brand-orange text-sm uppercase tracking-[0.15em]">Why us</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-slate-900 mt-3 mb-4">Why families choose us</h2>
          <p className="font-body text-slate-600 leading-relaxed mb-10">Caring for people, supporting providers — with the warmth of a friend and the reliability of a professional team.</p>

          <div className="space-y-7">
            {whyChoose.map((item, i) => {
              const Icon = Icons[item.icon] || Icons.Heart;
              return (
                <div key={i} className="flex items-start gap-5">
                  <div className="w-12 h-12 rounded-2xl bg-brand-blue-light flex items-center justify-center shrink-0">
                    <Icon className="w-6 h-6 text-brand-blue" strokeWidth={1.8} />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-lg text-slate-900 mb-1">{item.title}</h3>
                    <p className="font-body text-sm text-slate-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
